import { render, staticRenderFns } from "./bug-report-modal.vue?vue&type=template&id=29481b95"
import script from "./bug-report-modal.vue?vue&type=script&lang=js"
export * from "./bug-report-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports